import { useNavigate } from 'react-router-dom';
import './Consumable.css'
import { ConsumableCard } from './consumableCard/ConsumableCard';
import { Vehicle } from '../../models/Vehicle';
import toast from 'react-hot-toast';
import { useStore } from '../../store/store';
import { translations } from '../../configs/translations';
import { ConsumableInfo, ConsumableService } from '../../services/ConsumableService';
import { useEffect, useState } from 'react';

interface Props {
    selectedVehicle: Vehicle | null;
}

export const ConsumableMenu = ({ selectedVehicle }: Props) => {

    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    const navigate = useNavigate()
    const navigateToShop = () => {
        if (selectedVehicle) {
            navigate('/consumable-shop?vehicleId=' + selectedVehicle?.id)
        } else {
            toast.error(t.vehicle_not_selected)
        }
    }

    const [consumableInfo, setConsumableInfo] = useState<ConsumableInfo | null>(null);

    const fetchInfo = async () => {
        await ConsumableService.fetchConsumableInfo(selectedVehicle?.id || 0)
            .then((response) => {
                console.log(response)
                setConsumableInfo(response);
            })
            .catch((error) => {
                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                        ? t[error.response.data as keyof typeof t] 
                        : t.error_unknown,
                    { className: 'notification-error' }
                );
            });
    }

    useEffect(() => {
        if (selectedVehicle) {
            setConsumableInfo(null);
            fetchInfo();
        }
    }, [selectedVehicle]);

    return (
        <>
        {consumableInfo && (
            <div className='consumable-menu-container'>
                <div className='consumable-menu'>
                    <ConsumableCard 
                        type="fuel" 
                        text={consumableInfo?.remaining.FUEL.toFixed(1) + " " + t.liters_short}
                        onClick={() => navigateToShop()} />
                    <ConsumableCard 
                        type="oil" 
                        text={consumableInfo?.remaining.OIL.toFixed(1) + " " + t.liters_short}
                        onClick={() => navigateToShop()} />
                    <ConsumableCard 
                        type="tyre" 
                        text={consumableInfo?.remaining.TYRE.toFixed(1) + " " + t.amounts_short}
                        onClick={() => navigateToShop()} />
                    <ConsumableCard 
                        type="nitro" 
                        text={consumableInfo?.remaining.NITROUS.toFixed(1) + " %"}
                        onClick={() => navigateToShop()} />
                </div>
            </div>
        )}
        </>
    );
};